// Kiosk data: questions, mock inventory, recommendation engine, labels.

export const QUESTIONS = [
  {
    id: 'primary_goal',
    prompt: 'What is your primary goal?',
    options: [
      { value: 'muscle', label: 'Muscle & strength' },
      { value: 'energy', label: 'Energy & fatigue' },
      { value: 'sleep', label: 'Sleep quality' },
      { value: 'stress', label: 'Stress & anxiety' },
      { value: 'digestion', label: 'Digestion & gut health' },
      { value: 'beauty', label: 'Hair, skin & nails' },
    ],
  },
  {
    id: 'energy_type',
    prompt: 'How does your fatigue feel?',
    options: [
      { value: 'physical', label: 'Physically tired' },
      { value: 'mental', label: 'Mentally tired' },
      { value: 'both', label: 'Both' },
      { value: 'fine', label: 'I feel fine' },
    ],
  },
  {
    id: 'sleep_pattern',
    prompt: 'Which best describes your sleep?',
    options: [
      { value: 'falling', label: 'Trouble falling asleep' },
      { value: 'waking', label: 'Wake during the night' },
      { value: 'tired', label: 'Wake up tired' },
      { value: 'no_issues', label: 'No issues' },
    ],
  },
  {
    id: 'stress_type',
    prompt: 'What does your stress feel like?',
    options: [
      { value: 'racing', label: 'Racing thoughts' },
      { value: 'tension', label: 'Muscle tension' },
      { value: 'burnout', label: 'Burnout' },
      { value: 'none', label: 'Not much' },
    ],
  },
  {
    id: 'digestion',
    prompt: 'How is your digestion?',
    options: [
      { value: 'bloating', label: 'Bloating' },
      { value: 'slow', label: 'Slow digestion' },
      { value: 'irregular', label: 'Irregular bowel movements' },
      { value: 'no_issues', label: 'No issues' },
    ],
  },
  {
    id: 'diet',
    prompt: 'How would you describe your diet?',
    options: [
      { value: 'whole', label: 'Mostly whole foods' },
      { value: 'mixed', label: 'Mixed' },
      { value: 'processed', label: 'Mostly processed' },
    ],
  },
  {
    id: 'activity',
    prompt: 'How active are you?',
    options: [
      { value: 'rare', label: 'Rarely' },
      { value: 'medium', label: '2–3× per week' },
      { value: 'high', label: '4+ times per week' },
    ],
  },
  {
    id: 'recovery',
    prompt: 'How does your body recover?',
    options: [
      { value: 'quick', label: 'Recover quickly' },
      { value: 'sore', label: 'Sore for days' },
      { value: 'fatigue', label: 'Fatigued after activity' },
    ],
  },
  {
    id: 'diet_pref',
    prompt: 'Any dietary preferences?',
    options: [
      { value: 'none', label: 'No preference' },
      { value: 'vegan', label: 'Vegan' },
      { value: 'vegetarian', label: 'Vegetarian' },
      { value: 'gluten_free', label: 'Gluten-free' },
    ],
  },
  {
    id: 'on_meds',
    prompt: 'Are you currently taking any medications?',
    options: [
      { value: 'no', label: 'No' },
      { value: 'yes', label: 'Yes' },
    ],
  },
  {
    id: 'medications',
    prompt: 'Which of these apply? (select any)',
    multi: true,
    dependsOn: { on_meds: 'yes' },
    // options are loaded from the backend at runtime; leave empty here
    options: [],
  },
  {
    id: 'med_duration',
    prompt: 'How long have you been taking them?',
    dependsOn: { on_meds: 'yes' },
    options: [
      { value: 'lt_3_months',    label: 'Less than 3 months' },
      { value: '3_to_12_months', label: '3 to 12 months' },
      { value: '1_to_3_years',   label: '1 to 3 years' },
      { value: '3_plus_years',   label: '3+ years' },
    ],
  },
];

// Mock inventory: 20 products, explicitly typed.
export const INVENTORY = [
  // creatine
  { sku: 'CR-001', name: 'Creatine Monohydrate 300g',     price: 39.99, type: 'creatine', priority: 9, in_stock: true },
  { sku: 'CR-002', name: 'Creatine HCL 120 caps',         price: 29.99, type: 'creatine', priority: 5, in_stock: true },
  // nitric_oxide
  { sku: 'NO-001', name: 'L-Citrulline Malate 500g',      price: 34.99, type: 'nitric_oxide', priority: 8, in_stock: true },
  { sku: 'NO-002', name: 'Beet Root Extract 60 caps',     price: 24.99, type: 'nitric_oxide', priority: 6, in_stock: true },
  // testosterone_support
  { sku: 'TS-001', name: 'Tongkat Ali 400mg',             price: 44.99, type: 'testosterone_support', priority: 8, in_stock: true },
  { sku: 'TS-002', name: 'Zinc Picolinate 50mg',          price: 18.99, type: 'testosterone_support', priority: 7, in_stock: true },
  // magnesium
  { sku: 'MG-001', name: 'Magnesium Glycinate 400mg',     price: 27.99, type: 'magnesium', priority: 9, in_stock: true },
  { sku: 'MG-002', name: 'Magnesium Citrate 200mg',       price: 19.99, type: 'magnesium', priority: 6, in_stock: true },
  // theanine
  { sku: 'TH-001', name: 'L-Theanine 200mg',              price: 22.99, type: 'theanine', priority: 8, in_stock: true },
  { sku: 'TH-002', name: 'Theanine + GABA Calm Blend',    price: 28.99, type: 'theanine', priority: 5, in_stock: true },
  // adaptogen
  { sku: 'AD-001', name: 'Ashwagandha KSM-66 600mg',      price: 32.99, type: 'adaptogen', priority: 9, in_stock: true },
  { sku: 'AD-002', name: 'Rhodiola Rosea 500mg',          price: 26.99, type: 'adaptogen', priority: 7, in_stock: true },
  // digestive_enzymes
  { sku: 'DE-001', name: 'Full-Spectrum Digestive Enzymes', price: 29.99, type: 'digestive_enzymes', priority: 8, in_stock: true },
  { sku: 'DE-002', name: 'Betaine HCL with Pepsin',       price: 24.99, type: 'digestive_enzymes', priority: 6, in_stock: true },
  // probiotic
  { sku: 'PB-001', name: '50B CFU Daily Probiotic',       price: 39.99, type: 'probiotic', priority: 9, in_stock: true },
  { sku: 'PB-002', name: 'Refrigerated Probiotic 30 caps',price: 34.99, type: 'probiotic', priority: 7, in_stock: true },
  // collagen
  { sku: 'CL-001', name: 'Marine Collagen Peptides 250g', price: 36.99, type: 'collagen', priority: 8, in_stock: true },
  { sku: 'CL-002', name: 'Bovine Collagen Type I & III',  price: 32.99, type: 'collagen', priority: 6, in_stock: true },
  // multivitamin
  { sku: 'MV-001', name: 'Whole-Food Daily Multivitamin', price: 41.99, type: 'multivitamin', priority: 9, in_stock: true },
  { sku: 'MV-002', name: "Men's Performance Multivitamin",price: 38.99, type: 'multivitamin', priority: 6, in_stock: true },
];

// Human-readable labels per type.
export const TYPE_LABELS = {
  creatine: 'Creatine',
  nitric_oxide: 'Nitric Oxide Booster',
  testosterone_support: 'Testosterone Support',
  protein: 'Protein',
  magnesium: 'Magnesium',
  theanine: 'L-Theanine',
  adaptogen: 'Adaptogens',
  digestive_enzymes: 'Digestive Enzymes',
  probiotic: 'Probiotic',
  collagen: 'Collagen',
  multivitamin: 'Multivitamin',
  coq10: 'Coenzyme Q10',
  b_complex: 'B-Complex',
  calcium_d: 'Calcium & Vitamin D',
};

// Plain-language reasons per type.
export const TYPE_REASONS = {
  creatine: 'For strength, muscle output and explosive energy.',
  nitric_oxide: 'Improves blood flow, pumps and workout endurance.',
  testosterone_support: 'Supports hormonal balance and male recovery.',
  protein: 'Builds and repairs muscle; supports recovery and satiety.',
  magnesium: 'Helps relaxation, sleep, regularity and muscle function.',
  theanine: 'Calms a busy mind without sedation.',
  adaptogen: 'Helps your body adapt to mental and physical stress.',
  digestive_enzymes: 'Reduces bloating and supports complete digestion.',
  probiotic: 'Restores healthy gut flora and immune balance.',
  collagen: 'Supports joints, skin, hair and recovery.',
  multivitamin: 'Daily nutritional foundation when diet is inconsistent.',
  coq10: 'Cellular energy production; often depleted by statins and beta-blockers.',
  b_complex: 'Nervous-system support and energy; commonly lowered by PPIs, metformin and birth control.',
  calcium_d: 'Bone mineral density and calcium absorption support.',
};

// Color tint per type (used in product image swatch).
export const TYPE_COLORS = {
  creatine: '#dc2626',
  nitric_oxide: '#ea580c',
  testosterone_support: '#b45309',
  protein: '#9333ea',
  magnesium: '#16a34a',
  theanine: '#0891b2',
  adaptogen: '#7c3aed',
  digestive_enzymes: '#65a30d',
  probiotic: '#0d9488',
  collagen: '#db2777',
  multivitamin: '#2563eb',
  coq10: '#f59e0b',
  b_complex: '#f97316',
  calcium_d: '#0ea5e9',
};

// Wellness Suite — shown as an optional service recommendation alongside supplements.
export const WELLNESS_SUITE = {
  type: 'wellness_suite',
  name: 'Wellness Suite Experience',
  description:
    'Complement your personalized wellness plan with a relaxing Wellness Suite session designed to support your overall wellness routine.',
  price_label: 'Starting at $69',
  features: ['Infrared Sauna', 'Red-Light Therapy', '4D Massage Chair', 'Aromatherapy', 'Relaxing Music'],
  color: '#d97736',
  booking_url: '/booking',
};

// Triggers: show wellness suite when these goals / signals are present.
const WELLNESS_SUITE_GOAL_SET = new Set(['sleep', 'stress', 'beauty', 'energy']);

export function shouldRecommendWellnessSuite(answers) {
  const a = answers || {};
  if (WELLNESS_SUITE_GOAL_SET.has(a.primary_goal))                      return true;
  if (a.sleep_pattern && a.sleep_pattern !== 'no_issues')                return true;
  if (a.stress_type   && a.stress_type   !== 'none')                     return true;
  if (a.recovery === 'sore' || a.recovery === 'fatigue')                 return true;
  if (a.activity === 'high')                                             return true;
  return false;
}

// getTopProduct(type): filter in_stock + same type, sort by priority desc, return top.
export function getTopProduct(type) {
  return (
    INVENTORY
      .filter((p) => p.type === type && p.in_stock)
      .sort((a, b) => b.priority - a.priority)[0] || null
  );
}

// recommendCategories(answers): map answers → up to 4 categories.
// Insertion order is meaningful; we honor the first 4.
export function recommendCategories(answers) {
  const cats = new Set();
  const a = answers || {};

  // Q1 — primary goal sets the strongest signal first.
  if (a.primary_goal === 'muscle')    { cats.add('protein'); cats.add('creatine'); cats.add('nitric_oxide'); }
  if (a.primary_goal === 'energy')    cats.add('adaptogen');
  if (a.primary_goal === 'sleep')     cats.add('magnesium');
  if (a.primary_goal === 'stress')    cats.add('adaptogen');
  if (a.primary_goal === 'digestion') cats.add('probiotic');
  if (a.primary_goal === 'beauty')    cats.add('collagen');

  // Q7 — high activity also drives muscle support.
  if (a.activity === 'high') { cats.add('protein'); cats.add('creatine'); cats.add('nitric_oxide'); }

  // Q2 — energy type.
  if (a.energy_type === 'mental' || a.energy_type === 'both') {
    cats.add('theanine');
    cats.add('adaptogen');
  }
  if (a.energy_type === 'physical' || a.energy_type === 'both') {
    cats.add('magnesium');
  }

  // Q3 — sleep issues.
  if (a.sleep_pattern && a.sleep_pattern !== 'no_issues') {
    cats.add('magnesium');
    cats.add('theanine');
  }

  // Q4 — stress.
  if (a.stress_type === 'racing')  { cats.add('theanine'); cats.add('adaptogen'); }
  if (a.stress_type === 'tension') cats.add('magnesium');
  if (a.stress_type === 'burnout') { cats.add('adaptogen'); cats.add('magnesium'); }

  // Q5 — digestion.
  if (a.digestion === 'bloating')  cats.add('digestive_enzymes');
  if (a.digestion === 'slow')      cats.add('digestive_enzymes');
  if (a.digestion === 'irregular') cats.add('magnesium');

  // Q6 — diet.
  if (a.diet === 'processed') cats.add('multivitamin');

  // Q8 — recovery.
  if (a.recovery === 'sore')    { cats.add('protein'); cats.add('creatine'); cats.add('magnesium'); cats.add('collagen'); }
  if (a.recovery === 'fatigue') { cats.add('adaptogen'); cats.add('magnesium'); }

  // Cap to 4 categories total.
  return Array.from(cats).slice(0, 4);
}
